"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrosiveRainRebalanced = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var CorrosiveRainDeferredActionRebalanced_1 = require("../../deferredActions/CorrosiveRainDeferredActionRebalanced");
var CorrosiveRainRebalanced = (function () {
    function CorrosiveRainRebalanced() {
        this.name = GlobalEventName_1.GlobalEventName.CORROSIVE_RAIN_REBALANCED;
        this.description = 'Lose 2 floaters from a card or 7 M€. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    CorrosiveRainRebalanced.prototype.resolve = function (game, turmoil) {
        game.getPlayers().forEach(function (player) {
            player.drawCard(turmoil.getPlayerInfluence(player));
            game.defer(new CorrosiveRainDeferredActionRebalanced_1.CorrosiveRainDeferredActionRebalanced(player));
        });
    };
    return CorrosiveRainRebalanced;
}());
exports.CorrosiveRainRebalanced = CorrosiveRainRebalanced;
//# sourceMappingURL=CorrosiveRainRebalanced.js.map